import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  text: string;
  level: string;
}
const testimonials: TestimonialProps[] = [{
  name: 'Alejandro M.',
  age: 34,
  level: '4ta Categoría',
  text: 'Siempre me cansaba en el segundo set y perdía potencia. Con este plan, mis piernas aguantan todo el partido y mi drive está más pesado que nunca. Increíble la diferencia en un mes.'
}, {
  name: 'Sebastián R.',
  age: 41,
  level: '3ra Categoría',
  text: 'Jugaba bien técnicamente pero me pasaban por encima físicamente. El módulo de fuerza de saque me sumó muchísima velocidad y ya no me duele el hombro después de jugar.'
}, {
  name: 'Martín G.',
  age: 28,
  level: '2da Categoría',
  text: 'La rutina de activación pre-partido vale oro. Entro a la cancha prendido fuego desde el primer game. El mejor material de tenis que compré.'
}, {
  name: 'Federico L.',
  age: 37,
  level: 'Amateur',
  text: 'Pensé que a mi edad ya no podía mejorar mi explosión. Estaba equivocado. El plan es súper claro y fácil de seguir, incluso si no tenés mucho tiempo.'
}, {
  name: 'Pablo C.',
  age: 45,
  level: '4ta Categoría',
  text: 'El cuaderno táctico para jugar contra zurdos me salvó en el último torneo. Muy completo todo el sistema, 100% recomendado para los que jugamos torneos de club.'
}];
export function Testimonials() {
  return <div className="py-8" data-id="element-157">
      <h3 className="text-2xl font-black text-center text-white mb-6 uppercase italic" data-id="element-158">
        Lo que dicen los jugadores
      </h3>
      <div className="flex flex-col gap-4" data-id="element-159">
        {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-5 relative overflow-hidden" data-id="element-160">
            <div className="absolute top-0 right-0 w-16 h-16 bg-tennis-green/20 rounded-bl-full -z-10" data-id="element-161"></div>
            <div className="flex gap-1 mb-3" data-id="element-162">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-tennis-yellow text-tennis-yellow" data-id="element-163" />)}
            </div>
            <p className="text-white/90 text-sm italic mb-4" data-id="element-164">"{t.text}"</p>
            <div className="flex items-center justify-between border-t border-white/10 pt-3" data-id="element-165">
              <div data-id="element-166">
                <p className="text-white font-bold text-sm" data-id="element-167">{t.name}</p>
                <p className="text-gray-400 text-xs" data-id="element-168">
                  {t.age} años - {t.level}
                </p>
              </div>
              <div className="bg-tennis-green/20 text-tennis-green px-2 py-1 rounded text-xs font-bold" data-id="element-169">
                Comprador Verificado
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}